import React from 'react';
import _ from 'lodash';
import { Link } from 'gatsby';
import { buttonLengthConstants, buttonVariantConstants } from '../../common/constants';
import { ProductComparisonProductVariant } from '../../../.storyblok/types/255103/storyblok-components';
import Row from '../FlexboxGrid/Row';
import LooxRating from './LooxRating';
import PriceRange from '../Product/PriceRange';
import ButtonRegular from '../Button/ButtonRegular';
import { getStoryblokAspectRatio } from '../../utils/storyblokAsset';

type ProductComparisonRowFixedScrollProps = {
  activeVariant: ProductComparisonProductVariant;
};

/**
 * Product comparison row, to render in fixed display on user scroll.
 */
const ProductComparisonRowFixedScroll = (props: ProductComparisonRowFixedScrollProps) => {
  const { activeVariant } = props;

  return (
    // @ts-expect-error Row is not yet typed
    <Row
      className="pt-[54px] sm:pt-[60px] md:pt-[71px] lg:pt-[65px] pb-[20px] sm:pb-[40px] md:pb-[50px] lg:pb-[60px] m-0
        flex-col md:flex-row flex-nowrap gap-x-4 gap-y-2 sm:gap-y-8 md:gap-y-0 max-w-[650px] [&_.loox-rating]:pb-0
        productComparisonRowFixedScroll"
    >
      {/* left column: image */}
      <div className="md:basis-[180px] grow-0 shrink-0 text-center">
        {!_.isEmpty(activeVariant) && (
          <Link to={activeVariant.slug ? `/shop/${activeVariant.slug}` : ''} className="inline-block">
            <img
              alt={activeVariant.image?.alt ?? ''}
              className="w-[115px] sm:w-[125px] md:w-full max-w-full h-[115px] sm:h-[125px] md:h-[160px] lg:h-[180px]
                object-cover rounded-[15px]"
              src={activeVariant.image?.filename ?? ''}
            />
          </Link>
        )}
      </div>

      {/* right column: logotype, price, loox rating, button */}
      <div className="grow flex flex-col flex-wrap md:flex-nowrap gap-y-1 h-auto sm:h-[85px] md:h-auto justify-center">
        {/* logotype */}
        {!_.isEmpty(activeVariant) && (
          <Link to={activeVariant.slug ? `/shop/${activeVariant.slug}` : ''}>
            <img
              alt={activeVariant.logo?.alt ?? ''}
              className="w-[90px] md:w-[110px] lg:w-[130px] block"
              style={{ aspectRatio: getStoryblokAspectRatio(activeVariant.logo) }}
              src={activeVariant.logo?.filename ?? ''}
            />
          </Link>
        )}

        {/* price */}
        {!_.isEmpty(activeVariant) && (
          <PriceRange
            className="typography-body-m lg:typography-body-xxl !font-bold !text-navy-600"
            minPrice={Number(activeVariant.price)}
          />
        )}

        {/* loox rating, button */}
        <div
          className="basis-full md:basis-auto flex flex-row flex-wrap justify-center sm:justify-between items-center
            md:items-end gap-x-4 gap-y-1"
        >
          {/* loox */}
          {!_.isEmpty(activeVariant) && (
            <div className="hidden md:block">
              <LooxRating link={`/shop/${activeVariant.slug}#productReviews`} shopifyId={activeVariant.shopifyId} />
            </div>
          )}

          {!_.isEmpty(activeVariant) && (
            <Link to={activeVariant.slug ? `/shop/${activeVariant.slug}` : ''} className="contents">
              <ButtonRegular
                className="max-w-[90px] sm:max-w-[110px]"
                length={buttonLengthConstants.NORMAL}
                variant={buttonVariantConstants.PRIMARY_ORANGE}
              >
                Shop
              </ButtonRegular>
            </Link>
          )}
        </div>
      </div>
    </Row>
  );
};

export default React.memo(ProductComparisonRowFixedScroll);
